import { render, staticRenderFns } from "./congtaiMonitorItem.vue?vue&type=template&id=febe9e34&scoped=true&"
import script from "./congtaiMonitorItem.vue?vue&type=script&lang=js&"
export * from "./congtaiMonitorItem.vue?vue&type=script&lang=js&"
import style0 from "./congtaiMonitorItem.vue?vue&type=style&index=0&id=febe9e34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febe9e34",
  null
  
)

export default component.exports